export default "__VITE_ASSET__CO4AZ2wF__"